import React from 'react';
import { useGeneralStationsStyles } from 'Features/StationsNew/useStyles';
import { Pane } from 'evergreen-ui';
import { CreateStationButton } from 'Features/StationsNew/Station/Components';
import { useResetFilters } from './hooks';
import { MemoStationsFilters, MemoStationsFoundCount } from './Stations';
import { DatasourcesFilter } from './Datasources';
import { MemoResetFilters } from './ResetFilters';

type StationsFilterFullProps = {
  isShowCreateButton?: boolean
}

export default function StationsFilterFull({
  isShowCreateButton = true,
}: StationsFilterFullProps) {
  const classes = useGeneralStationsStyles();
  // note: айди будут по возрастанию, а значит и отображаться также - не знаю так надо или нет
  const { disabledReset, onClickReset } = useResetFilters();
  return (
    <Pane padding=".5rem" display="flex" flexDirection="column" gap=".2rem">
      <Pane className={classes.filterRow} gridTemplateColumns="1fr max-content">
        <MemoStationsFilters />
        {isShowCreateButton && <CreateStationButton />}
      </Pane>

      <Pane className={classes.filterRow} gridTemplateColumns="1fr max-content max-content">
        <DatasourcesFilter />
        <MemoStationsFoundCount justifySelf="end" />
        <MemoResetFilters onClick={onClickReset} disabled={disabledReset} />
      </Pane>
    </Pane>
  );
}
